<template>
  <span class="card-holder-cell">
    <span class="card-holder-cell__name">{{ holder }}</span>
    <span v-if="showNameOnCard" class="card-holder-cell__name-on-card">{{ nameOnCard }}</span>
  </span>
</template>

<script>
  export default {
    computed: {
      holder() {
        return (this.params && this.params.value) || ''
      },
      nameOnCard() {
        return ((this.params && this.params.data && this.params.data.NameOnCard) || '').trim()
      },
      showNameOnCard() {
        return !!this.nameOnCard && this.nameOnCard !== (this.holder || '').trim()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/_variables.scss";

  // The grid uses a 35px fixed row height (see Grid/index.vue ROW_HEIGHT). Keep
  // both lines tight so the cell does not clip when a custom Name on Card is shown.
  .card-holder-cell {
    display: inline-flex;
    flex-direction: column;
    line-height: 1.1;
    vertical-align: middle;

    &__name-on-card {
      font-size: 0.8em;
      color: $brand-secondary;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-cards/CardHolder.vue